import React from 'react';

/**
 * Ícones em SVG inline usados apenas na página pública LegisPocket.
 * Inline para a página não depender de nenhuma biblioteca de ícones e
 * herdar cor/tamanho direto do CSS (currentColor).
 */

export type NomeIcone =
    | 'radar'
    | 'agente'
    | 'whatsapp'
    | 'sino'
    | 'grafico'
    | 'lampada'
    | 'escudo'
    | 'check'
    | 'seta'
    | 'instituicao'
    | 'documento'
    | 'lupa'
    | 'pessoas'
    | 'relogio'
    | 'agenda'
    | 'alvo'
    | 'camadas'
    | 'raio'
    | 'balanca'
    | 'conversa'
    | 'mapa';

const TRACO = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
};

const CAMINHOS: Record<NomeIcone, JSX.Element> = {
    radar: (
        <>
            <path {...TRACO} d="M12 12 4.6 7.2A8.5 8.5 0 1 1 3.6 14" />
            <path {...TRACO} d="M12 12l4.6-3" />
            <circle {...TRACO} cx="12" cy="12" r="1.4" />
            <path {...TRACO} d="M7.7 12a4.3 4.3 0 0 1 4.3-4.3" />
        </>
    ),
    agente: (
        <>
            <rect {...TRACO} x="4" y="8" width="16" height="12" rx="3.5" />
            <path {...TRACO} d="M12 4.2v3.8M8.8 13.4v1.4M15.2 13.4v1.4M9.6 17.4h4.8" />
            <circle {...TRACO} cx="12" cy="3" r="1.2" />
        </>
    ),
    whatsapp: (
        <>
            <path {...TRACO} d="M20.2 11.7a8.2 8.2 0 0 1-12.2 7.1L3.8 20l1.2-4.1A8.2 8.2 0 1 1 20.2 11.7Z" />
            <path {...TRACO} d="M9.2 9.1c.2-.5.5-.5.8-.5h.5c.2 0 .4 0 .6.5l.6 1.4c.1.3 0 .5-.1.7l-.4.4c-.1.2-.2.4 0 .7.3.5 1.1 1.5 2.2 2 .3.1.5.1.7-.1l.5-.6c.2-.2.4-.2.6-.1l1.4.7c.3.1.4.3.4.6 0 .8-.6 1.5-1.4 1.6-.7.1-1.6.1-3.5-.9-1.8-.9-3-2.7-3.2-3.5-.2-.8-.1-1.9.3-2.9Z" />
        </>
    ),
    sino: (
        <>
            <path {...TRACO} d="M18 8.5a6 6 0 1 0-12 0c0 5-2 6.5-2 6.5h16s-2-1.5-2-6.5Z" />
            <path {...TRACO} d="M13.7 19a2 2 0 0 1-3.4 0" />
        </>
    ),
    grafico: (
        <>
            <path {...TRACO} d="M4 20h16" />
            <rect {...TRACO} x="5.5" y="12" width="3.4" height="6" rx="1" />
            <rect {...TRACO} x="10.3" y="8" width="3.4" height="10" rx="1" />
            <rect {...TRACO} x="15.1" y="4.5" width="3.4" height="13.5" rx="1" />
        </>
    ),
    lampada: (
        <>
            <path {...TRACO} d="M9.2 17.5a6 6 0 1 1 5.6 0" />
            <path {...TRACO} d="M9.6 17.5h4.8v1.6a2.4 2.4 0 0 1-4.8 0Z" />
            <path {...TRACO} d="M12 9v4" />
        </>
    ),
    escudo: (
        <>
            <path {...TRACO} d="M12 3.2 5 6v5.4c0 4.4 3 7.6 7 9.4 4-1.8 7-5 7-9.4V6Z" />
            <path {...TRACO} d="m9.3 12 1.9 1.9 3.6-3.7" />
        </>
    ),
    check: (
        <>
            <circle {...TRACO} cx="12" cy="12" r="8.6" />
            <path {...TRACO} d="m8.6 12.2 2.3 2.3 4.6-4.8" />
        </>
    ),
    seta: (
        <>
            <path {...TRACO} d="M4.5 12h14" />
            <path {...TRACO} d="m13 6.5 5.5 5.5L13 17.5" />
        </>
    ),
    instituicao: (
        <>
            <path {...TRACO} d="M3.6 9.4 12 4.6l8.4 4.8" />
            <path {...TRACO} d="M5.6 10.6v7.2M9.9 10.6v7.2M14.1 10.6v7.2M18.4 10.6v7.2" />
            <path {...TRACO} d="M3.4 19.4h17.2" />
        </>
    ),
    documento: (
        <>
            <path {...TRACO} d="M13.4 3.5H7.6A2.1 2.1 0 0 0 5.5 5.6v12.8a2.1 2.1 0 0 0 2.1 2.1h8.8a2.1 2.1 0 0 0 2.1-2.1V8.4Z" />
            <path {...TRACO} d="M13.4 3.5v4.9h5.1" />
            <path {...TRACO} d="M8.9 12.6h6.2M8.9 16h4.2" />
        </>
    ),
    lupa: (
        <>
            <circle {...TRACO} cx="11" cy="11" r="6.4" />
            <path {...TRACO} d="m15.8 15.8 4 4" />
        </>
    ),
    pessoas: (
        <>
            <circle {...TRACO} cx="9.3" cy="8.6" r="3.2" />
            <path {...TRACO} d="M3.8 19.2a5.6 5.6 0 0 1 11 0" />
            <path {...TRACO} d="M16 6a3.2 3.2 0 0 1 0 5.6M17.2 14.4a5.6 5.6 0 0 1 3 4.8" />
        </>
    ),
    relogio: (
        <>
            <circle {...TRACO} cx="12" cy="12" r="8.4" />
            <path {...TRACO} d="M12 7.4V12l3 1.8" />
        </>
    ),
    agenda: (
        <>
            <rect {...TRACO} x="4" y="5.6" width="16" height="14.4" rx="2.6" />
            <path {...TRACO} d="M4 10h16M8.6 3.6v3.6M15.4 3.6v3.6" />
            <path {...TRACO} d="M8.4 13.8h2.2M8.4 16.8h5.6" />
        </>
    ),
    alvo: (
        <>
            <circle {...TRACO} cx="12" cy="12" r="8.4" />
            <circle {...TRACO} cx="12" cy="12" r="4.6" />
            <circle {...TRACO} cx="12" cy="12" r="1" />
        </>
    ),
    camadas: (
        <>
            <path {...TRACO} d="m12 3.6 8.2 4.3-8.2 4.3-8.2-4.3Z" />
            <path {...TRACO} d="m4 12.4 8 4.2 8-4.2" />
            <path {...TRACO} d="m4 16.6 8 4.2 8-4.2" />
        </>
    ),
    raio: (
        <>
            <path {...TRACO} d="M13.4 3.2 5.6 13.4h5.2l-.8 7.4 7.8-10.2h-5.2Z" />
        </>
    ),
    balanca: (
        <>
            <path {...TRACO} d="M12 4.2v15.6M7.4 19.8h9.2M5.2 7.8h13.6" />
            <path {...TRACO} d="M8.4 7.8 5.4 14h6ZM15.6 7.8 12.6 14h6Z" />
            <circle {...TRACO} cx="12" cy="4.6" r="1.3" />
        </>
    ),
    conversa: (
        <>
            <path {...TRACO} d="M20 12.4c0 3.8-3.6 6.9-8 6.9-1 0-2-.2-2.9-.5L4.4 20.4l1.3-3.7a6.6 6.6 0 0 1-1.7-4.3c0-3.8 3.6-6.9 8-6.9s8 3.1 8 6.9Z" />
            <path {...TRACO} d="M9 12.3h.01M12 12.3h.01M15 12.3h.01" />
        </>
    ),
    mapa: (
        <>
            <path {...TRACO} d="m3.8 6.6 5.3-2.2 5.8 2.2 5.3-2.2v12.9l-5.3 2.2-5.8-2.2-5.3 2.2Z" />
            <path {...TRACO} d="M9.1 4.4v14.9M14.9 6.6v14.9" />
        </>
    ),
};

interface IconeProps { nome: NomeIcone; }

export function Icone({ nome }: IconeProps): JSX.Element {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            {CAMINHOS[nome]}
        </svg>
    );
}

export default Icone;
